module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Colorado PGA-bbdabd394e3d74e70ecf9fb54c11e212.png";